export default __webpack_public_path__ + "static/media/arrow-up-long-line.786c6bde.svg";